import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  LOGIN_VERIFICATION_SUCCESS,
  USER_UPDATE,
} from "./authActions";

const parseStoredRoles = (value) => {
  if (!value) return null;

  if (Array.isArray(value)) return value;

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : parsed ? [parsed] : null;
    } catch {
      return [value];
    }
  }

  if (typeof value === "object") {
    if (Array.isArray(value.roles)) return value.roles;
    if (typeof value.role === "string") return [value.role];
  }

  return null;
};

const initialId = localStorage.getItem("id");
const initClinicId = localStorage.getItem("clinicId") || null;
const isAuthenticated = localStorage.getItem("isAuthenticated") || false;
const initRoles = parseStoredRoles(localStorage.getItem("roles"));
const intProfileImage = localStorage.getItem("profileImage") || null;
const initClinicLogo=localStorage.getItem("clinicLogo") || null;
const initName=localStorage.getItem("name") || null;

const initialState = {
  isAuthenticated: isAuthenticated || false, 
  clinicId: initClinicId || null,
  id: initialId || null,
  roles: initRoles || null,
  name: initName || null,
  error: null,
  loading: false,
  profileImage: intProfileImage || null,
  clinicLogo: initClinicLogo || null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case USER_UPDATE:
       const { newProfileImage=null,newClinicLogo=null, newName=null } = action.payload;
        localStorage.setItem("profileImage", newProfileImage || state.profileImage);
        localStorage.setItem("clinicLogo", newClinicLogo || state.clinicLogo);
        localStorage.setItem("name", newName || state.name);
        return {
        ...state,
        profileImage: newProfileImage || state.profileImage,
        clinicLogo: newClinicLogo || state.clinicLogo,
        name: newName || state.name,
      };
 

    case LOGIN_VERIFICATION_SUCCESS:
      const { id = null, clinicId = null, roles = null, profileImage=null, clinicLogo=null ,name=null} = action.payload;
      const normalizedRoles = parseStoredRoles(roles);
      localStorage.setItem("id", id);
      localStorage.setItem("clinicId", clinicId || "");
      localStorage.setItem("isAuthenticated", true);
      localStorage.setItem("roles", JSON.stringify(normalizedRoles || []));
      localStorage.setItem("profileImage", profileImage);
      localStorage.setItem("clinicLogo", action.payload.clinicLogo || "");
      localStorage.setItem("name", action.payload.name || "");
      return {
        ...state,
        isAuthenticated: true,
        clinicId,
        id,
        roles: normalizedRoles,
        name,
        profileImage,
        clinicLogo,
        loading: false,
        error: false,
      };
    case LOGIN_FAILURE:
      localStorage.removeItem("id");
      localStorage.removeItem("clinicId");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("roles");
      localStorage.removeItem("profileImage");
      localStorage.removeItem("clinicLogo");
      localStorage.removeItem("name");
      
      return {
        ...state,
        isAuthenticated: false,
        clinicId: null,
        id: null,
        roles: null,
        name: null,
        profileImage: null,
        clinicLogo: null,
        error: action.payload,
        loading: false,
      };
    case LOGOUT:
      localStorage.removeItem("id");
      localStorage.removeItem("clinicId");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("roles");
      localStorage.removeItem("profileImage");
      localStorage.removeItem("clinicLogo");
      localStorage.removeItem("name");
      localStorage.removeItem("permissions");
      return {
        ...state,
        isAuthenticated: false,
        clinicId: null,
        id: null,
        roles: null,
        name: null,
        profileImage: null,
        loading: false,
        error: null,
        profileImage: null,
        clinicLogo: null,
      };
    default:
      return state;
  }
};

export default authReducer;
